import React, { Suspense } from 'react';
import { MarketplaceSwitcherProps } from 'src/features/header/components/MarketplaceSwitcher/MarketplaceSwitcher';

/*
 * The region switcher only renders for DSP entities, but its package
 * (@amzn/d16-g-adsp-region-switcher-ui) is the one CommonJS consumer of
 * @amzn/storm-ui in this bundle. Loading it lazily keeps the switcher and its
 * dependencies out of the synchronous shell for every other console.
 */
const RegionSwitcherInner = React.lazy(
  () =>
    import(/* webpackChunkName: "region-switcher" */ './RegionSwitcherInner'),
);

const RegionSwitcher: React.VFC<MarketplaceSwitcherProps> = (props) => (
  <Suspense fallback={null}>
    <RegionSwitcherInner {...props} />
  </Suspense>
);

export default RegionSwitcher;
